import { render, staticRenderFns } from "./huiFuDetail.vue?vue&type=template&id=1aad71cd&scoped=true&"
import script from "./huiFuDetail.vue?vue&type=script&lang=js&"
export * from "./huiFuDetail.vue?vue&type=script&lang=js&"
import style0 from "./huiFuDetail.vue?vue&type=style&index=0&id=1aad71cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aad71cd",
  null
  
)

export default component.exports